import { Alert, Box, Button, Grid, Grow, Snackbar, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Link } from "react-router-dom";
import dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";
import "dayjs/locale/pt-br";
import useStyles from "./styles";
import {
	CentralAlertasProvider,
	useCentralAlertas,
} from "../../../components/centralDeAlertas/context";
import FiltrosDashboard from "../../../components/centralDeAlertas/filtrosDashboard";
import KpiCards from "../../../components/centralDeAlertas/kpiCards";
import GraficoAlertas from "../../../components/centralDeAlertas/graficoAlertas";
import TopEquipamentos from "../../../components/centralDeAlertas/topEquipamentos";
import AlertasInteligentes from "../../../components/centralDeAlertas/alertasInteligentes";
import TimelineGlobal from "../../../components/centralDeAlertas/timelineGlobal";
import SlaPorCliente from "../../../components/centralDeAlertas/slaPorCliente";
import TabelaIncidentes from "../../../components/centralDeAlertas/tabelaIncidentes";

dayjs.extend(localizedFormat);
dayjs.locale("pt-br");

// Entrada escalonada dos blocos (stagger suave).
const ATRASO_STAGGER_MS = 90;

function BlocoAnimado({ ordem, sx, children }) {
	return (
		<Grow
			in
			timeout={450}
			style={{ transitionDelay: `${ordem * ATRASO_STAGGER_MS}ms` }}
		>
			<Box sx={sx}>{children}</Box>
		</Grow>
	);
}

function ConteudoCentralDeAlertas() {
	const theme = useTheme();
	const styles = useStyles(theme);
	const { toast, fecharToast, alertasOcultos } = useCentralAlertas();

	return (
		<>
			<FiltrosDashboard />
			<Box sx={styles.container}>
				<BlocoAnimado ordem={4} sx={styles.blocoCheio}>
					<Grid container spacing={2}>
						<Grid item xs={12} md={6} sx={styles.itemAlturaFeeds}>
							<TimelineGlobal />
						</Grid>
						<Grid item xs={12} md={6} sx={styles.itemAlturaFeeds}>
							<AlertasInteligentes />
						</Grid>
					</Grid>
				</BlocoAnimado>

				<BlocoAnimado ordem={5} sx={styles.blocoCheio}>
					<TabelaIncidentes />
				</BlocoAnimado>

				<Snackbar
					open={toast.aberto}
					autoHideDuration={3500}
					onClose={fecharToast}
					anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
				>
					<Alert onClose={fecharToast} severity="success" variant="filled">
						{toast.mensagem}
					</Alert>
				</Snackbar>
			</Box>
		</>
	);
}

export default function CentralDeAlertas() {
	return (
		<CentralAlertasProvider>
			<ConteudoCentralDeAlertas />
		</CentralAlertasProvider>
	);
}
